import { render } from "./CosmoSetup2.vue?vue&type=template&id=649f997c&scoped=true"
import script from "./CosmoSetup2.vue?vue&type=script&lang=js"
export * from "./CosmoSetup2.vue?vue&type=script&lang=js"

import "./CosmoSetup2.vue?vue&type=style&index=0&id=649f997c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649f997c"]])

export default __exports__